var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHide = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 .707 13.293 12l.707-.707L2.707 0zM.582 6a8.02 8.02 0 0 1 2.217-3.08l.71.71A7.025 7.025 0 0 0 1.673 6a7.001 7.001 0 0 0 8.004 3.798l.808.809A8.003 8.003 0 0 1 .581 6M6.323 2.202l-.808-.808A8.003 8.003 0 0 1 15.419 6 8.02 8.02 0 0 1 13.2 9.08l-.709-.71A7.025 7.025 0 0 0 14.327 6a7.001 7.001 0 0 0-8.004-3.798"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11 6a3 3 0 0 1-.102.777l-.902-.902a2 2 0 0 0-1.871-1.871l-.902-.902A3.004 3.004 0 0 1 11 6M5.102 5.223l.902.902a2 2 0 0 0 1.87 1.871l.903.902a3.004 3.004 0 0 1-3.675-3.675"
})));
export default SvgHide;